import type { CollectionModel } from "@/features/collections/api/models/CollectionModel";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface CollectionUpdateRequestModel {
	readonly name: string;
	readonly valued: boolean;
	readonly description: string;
	readonly pinned: boolean;
	readonly image: number;
}

export interface CollectionUpdateRequestProperties {
	readonly requestModel: CollectionUpdateRequestModel;
	readonly id: string;
}

export const useCollectionUpdate = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<CollectionModel>, CollectionUpdateRequestProperties> = requestProperties => {
		return http<CollectionModel, CollectionUpdateRequestModel>({
			method: "PUT",
			url: `/collection/${requestProperties.id}`,
			body: requestProperties.requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["collection"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardCurrentPosition"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardHistoricalPositions"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardPerformanceDeltas"] });
			queryClient.invalidateQueries({ queryKey: ["collectionHistoricalPositions"] });
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
			queryClient.invalidateQueries({ queryKey: ["goalCollection"] });
		}
	});
};
